import successSound from "../audio/notification.mp3";
import alertSound from "../audio/notification2.mp3";

// 🔔 Sons du site, téléchargés seulement au moment de les jouer. Avant : App.js les chargeait à
// l'ouverture de chaque page (107 Ko), même pour un visiteur qui n'en entend jamais. Fichiers
// importés : le build leur donne leur vrai nom (avec une empreinte).
// success : nouvelle demande de cours, cours qui commence, salle d'attente ; alert : inactivité.
const SOURCES = { success: successSound, alert: alertSound };
const players = {};

export const playSound = (name) => {
  if (!SOURCES[name]) return;
  try {
    if (!players[name]) players[name] = new Audio(SOURCES[name]);
    const audio = players[name];
    audio.currentTime = 0;
    const playing = audio.play();
    // Lecture bloquée par le navigateur (aucune action de l'utilisateur sur la page) : rien d'autre
    if (playing && playing.catch) playing.catch(() => {});
  } catch (err) {
    // Son indisponible : jamais bloquant
  }
};
